module.exports = __webpack_public_path__ + "static/media/bazylika.fed256de.jpg";